import * as React from 'react';

import {Icon} from '@spaced-out/ui-design-system/lib/components/Icon';
import {Tooltip} from '@spaced-out/ui-design-system/lib/components/Tooltip';

import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {useHistory} from 'src/rerouter';
import type {RowType} from 'src/types/byod';

import layoutCss from './dashboard-builder-canvas-layout.css';


export type TileDividerProps = {
  rowId: string;
  rowType: RowType;
  colIndex: number;
  pathname: string;
  interactive: boolean;
};

export const TileDivider = React.memo(
  ({rowId, rowType, colIndex, pathname, interactive}: TileDividerProps) => {
    const {t} = useLabelTranslation();
    const history = useHistory();

    if (!interactive) {
      return <div className={layoutCss.tileGap} />;
    }

    return (
      <div className={layoutCss.tileDivider}>
        <div className={layoutCss.tileDividerLine} />
        <div className={layoutCss.tileDividerActions}>
          <Tooltip body={t('Add_Report', 'Add Report')} placement="top">
            <button
              type="button"
              className={layoutCss.rowDividerBtn}
              aria-label={t('Add_Report', 'Add Report')}
              onClick={() =>
                history.push(
                  `${pathname}/widget/add?rowId=${rowId}&col=${colIndex}&rowType=${rowType}`,
                )
              }
            >
              <Icon
                name="square-poll-vertical"
                type="solid"
                size="medium"
                color="clickable"
              />
            </button>
          </Tooltip>
        </div>
      </div>
    );
  },
);
